__turbopack_context__.v({
  "active": "FeaturedField-module__4qiwsa__active",
  "captionLabel": "FeaturedField-module__4qiwsa__captionLabel",
  "fieldMatchContainer": "FeaturedField-module__4qiwsa__fieldMatchContainer",
  "matchWrapper": "FeaturedField-module__4qiwsa__matchWrapper",
});
